module.exports = __webpack_public_path__ + "static/media/[Art_and_Music]2010-07-18-2.ecabe3fe.md";